exports.ACTION = "action";
exports.ACTION_ADD_TO_CART = 'woocommerce_ajax_add_to_cart';
exports.PRODUCT_ID = 'product_id';
exports.PRODUCT_QUANTITY = 'product_qty';
exports.LINKS = 'links';
exports.INITIAL_QUANTITIES = 'initialQuantities';
exports.REQUEST_DEFAULT_CONFIG = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }};
